import React from 'react';
import { LANDING } from '@/constants/testIds';

export const HeroSceneSkeleton = () => (
  <div data-testid={LANDING.hero3dSkeleton} className="w-full h-full grid place-items-center">
    <div className="relative w-56 h-56">
      <div className="absolute inset-0 rounded-full border border-white/10" />
      <div className="absolute inset-4 rounded-full border border-[#FF6B1A]/40 animate-pulse" />
      <div className="absolute inset-10 rounded-full border border-[#39FF14]/40 animate-pulse" />
      <div className="absolute inset-16 rounded-full bg-[#FF6B1A]/40 blur-2xl" />
    </div>
  </div>
);
